"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        appearance: 'none',
        textAlign: 'left',
        backgroundColor: 'inherit',
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        '&[disabled]': {
            cursor: 'default',
            opacity: '0.5'
        }
    }
};
//# sourceMappingURL=style.js.map